import {
  AppData,
  CalcMode,
  Calculator,
} from "../../interface/functionalityInterface";
import { Flow } from "../baseQuantities/flow";
import { Power } from "../baseQuantities/power";
import { UnitLess } from "../baseQuantities/unitLess";

const standardMode: CalcMode = {
  id: "001standard",
  name: "standard",
  baseQuantities: [
    { ...Power },
    { ...Flow },
    {
      ...UnitLess,
      name: "temperature",
      symbol: "\u0394T",
    },
  ],
  equation: "P=1.2*\u0394T*Q",
};

export const airHeatCalc: Calculator = {
  type: AppData.CALCULATOR,
  updatedAt: "2022-09-26",
  name: "air heat",
  branch: "Thermal",
  difficulty: "simple",
  inputs: [standardMode],
  calculate: [
    {
      name: "standard",
      equations: [
        {
          target: "power",
          expression: "1.2 * (temperature) * (flow)",
        },
        {
          target: "temperature",
          expression: "(power) / (1.2 * (flow))",
        },
        {
          target: "flow",
          expression: "(power) / (1.2 * (temperature))",
        },
      ],
    },
  ],
};
